module.exports = __webpack_public_path__ + "img/icon_54@2x.b8f676e6.png";